import { Component, ViewEncapsulation } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pm-continue-on-mobile-modal',
  templateUrl: 'continue-on-mobile-modal.html',
  styleUrls: ['./continue-on-mobile-modal.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContinueOnMobileModal {
  private backButtonSub: Subscription;

  constructor(private platform: Platform) {}

  ionViewDidEnter() {
    this.backButtonSub = this.platform.backButton.subscribeWithPriority(9999, () => {
      // Block hardware back button — this modal cannot be dismissed
    });
  }

  ionViewWillLeave() {
    if (this.backButtonSub) {
      this.backButtonSub.unsubscribe();
    }
  }
}
